import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { PhaseController } from '@shared/src/controllers/route/phase/phase.controller';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { ShipmentController } from '@shared/src/controllers/route/shipment/shipment.controller';
import { Router } from '@angular/router';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { PhaseCardItemDto } from '@shared/src/dtos/phase/PhaseCardItemDto';
import { ParticipantDto } from '@shared/src/dtos/chat/participant/ParticipantDto';
import { ChatParticipantTypes } from '@shared/src/enums/ChatParticipantTypes';
import { MapMarcadorDto, MapService } from '@shared/src/services/map/map.service';

@Component({
    selector: 'shared-phase-info-component',
    templateUrl: './shared.phase.info.component.html',
    styleUrls: ['./shared.phase.info.component.scss'],
})
export class SharedPhaseInfoComponent {

    public useIonic: boolean = false;

    constructor(@Inject('HomeController') public homeController: HomeController,
        private phaseController: PhaseController,
        private routeController: RouteController, private shipmentController: ShipmentController,
        protected router: Router) {

        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    public routeId: number;
    public routeChatForcedOwnerParticipant: ParticipantDto;
    public options: OptionsStripDto;
    public selectedOptionId: string = "info";


    @Input()
    public isExwork: boolean = false;

    private _phase: PhaseCardItemDto;
    @Input() set phase(value: PhaseCardItemDto) {
        if (this._phase === value)
            return;
        this._phase = value;
        this.routeId = value.routeId;
        this.routeChatForcedOwnerParticipant = ParticipantDto.buildByParams(this.routeId, ChatParticipantTypes.Route);
        this.calculate();
        this.createOptions();
    }
    get phase(): PhaseCardItemDto {
        return this._phase;
    }




    public goToActiveSlots() {
        if (!this.useIonic)
            window.open(this.homeController.createRouteIdLinkToActiveSlots(this.routeId), '_blank');
        else
            this.router.navigateByUrl(this.homeController.createRouteIdLinkToActiveSlotsMobile(this.routeId));
    }

    public goToActiveRoute() {
        if (!this.useIonic)
            window.open(this.homeController.createRouteIdLinkToActiveRoutes(this.routeId), '_blank');
        else
            this.router.navigateByUrl(this.homeController.createRouteIdLinkToActiveRoutesMobile(this.routeId));
    }


    onClickOption(option: OptionDto) {
        if (option != null)
            this.selectedOptionId = option.optionId;
        else
            this.selectedOptionId = "";
    }


    // Mapa
    public zoom: number = MapService.DEFAULT_GOOGLEMAPS_ADDRESS_ZOOM;
    public marcadors: Array<MapMarcadorDto> = new Array<MapMarcadorDto>();
    private calculate() {
        this.marcadors.push(MapMarcadorDto.builder(this._phase.longitude, this._phase.latitude).adreça());
    }

    createOptions() {
        this.options = new OptionsStripDto;
        this.options.add(OptionDto.build("info", "(i)", "", "", 0, -1, 1, true, false))
        this.options.add(OptionDto.build("slot", "PHASE.INFO.OPTION.SLOT.CAPTION", "", "", 1, -1, 1, false, false))
        this.options.add(OptionDto.build("historial", "PHASE.INFO.OPTION.HISTORIAL.CAPTION", "", "", 2, -1, 1, false, false))

        if (!this.isExwork)
            this.options.add(OptionDto.build("notes", "PHASE.INFO.OPTION.NOTES.CAPTION", "", "", 3, -1, 1, false, false))
    }

    pretty(value) {
        return JSON.stringify(value);
    }
}
